export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/dfffdcc654f425d556d7485c2bf841db.svg";